/**
 * Types for ChatView components
 */ export function isMessagePartTool(part) {
    return part.type.startsWith('tool-') || part.type === 'dynamic-tool';
}
export function isMessagePartArtifact(part) {
    return part.type === 'data-artifact';
}
export function isMessagePartAttachments(part) {
    return part.type === 'data-attachments';
}
export function isMessagePartReasoning(part) {
    return part.type === 'reasoning';
}
export function isMessagePartText(part) {
    return part.type === 'text';
}
export function isMessagePartLCATProgress(part) {
    return part.type === 'data-lcat-progress';
}
